// extracted by mini-css-extract-plugin
module.exports = {"container":"NmcContent_container__10eA4","frame":"NmcContent_frame__2ZQpw","spin":"NmcContent_spin__3I2eA"};